import React from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/select';
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../../components/ui/dialog';
import { FormField } from '../../../components/app';
import { ExpenseDialogProps } from '../types';

export function ExpenseDialog({
  isOpen,
  onOpenChange,
  payers,
  formData,
  onFormDataChange,
  onSubmit,
  title,
  description,
  submitLabel,
  isSubmitting = false,
}: ExpenseDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl p-0">
        <DialogHeader bordered>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <DialogBody>
          <div className="grid gap-4 sm:grid-cols-2">
            <FormField label="Дата" required>
              <Input
                type="date"
                value={formData.date}
                onChange={(e) => onFormDataChange((prev) => ({ ...prev, date: e.target.value }))}
              />
            </FormField>
            <FormField label="Сумма, сум" required>
              <Input
                type="number"
                min={0}
                inputMode="decimal"
                value={formData.amount}
                onChange={(e) => onFormDataChange((prev) => ({ ...prev, amount: parseFloat(e.target.value) || 0 }))}
              />
            </FormField>
          </div>
          <FormField label="Заголовок" required>
            <Input
              value={formData.title}
              onChange={(e) => onFormDataChange((prev) => ({ ...prev, title: e.target.value }))}
              placeholder="Напр. Хостинг DigitalOcean"
            />
          </FormField>
          <FormField
            label="Плательщик"
            required
            hint="Основатель — растёт Долг перед ним; Счёт компании — уменьшается Касса"
            error={payers.length === 0 ? 'Сначала добавьте Плательщика (кнопка «Плательщики»)' : undefined}
          >
            {(p) => (
              <Select
                value={formData.payerId}
                onValueChange={(value) => onFormDataChange((prev) => ({ ...prev, payerId: value }))}
              >
                <SelectTrigger {...p}>
                  <SelectValue placeholder="Выберите плательщика" />
                </SelectTrigger>
                <SelectContent>
                  {payers.map((payer) => (
                    <SelectItem key={payer.id} value={payer.id}>
                      {payer.name}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            )}
          </FormField>
          <FormField label="Описание">
            <Input
              value={formData.description || ''}
              onChange={(e) => onFormDataChange((prev) => ({ ...prev, description: e.target.value }))}
              placeholder="Необязательно"
            />
          </FormField>
        </DialogBody>
        <DialogFooter bordered>
          <Button variant="secondary" onClick={() => onOpenChange(false)} disabled={isSubmitting}>
            Отмена
          </Button>
          <Button onClick={onSubmit} disabled={isSubmitting}>
            {isSubmitting && <Loader2 className="animate-spin" />}
            {submitLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
